import { createGlobalStyle } from 'styled-components';

export const GliaGlobalStyle = createGlobalStyle`
  #salemove .sm-visitor-app {
    bottom: revert !important;
    top: 90px !important;

    @media (min-width: 1350px) {
      top: unset !important;
      bottom: 30px !important;
    }
  }
`;
